import { useEffect, useRef, useState } from "react";
import useResizeObserver from "@react-hook/resize-observer";
import { GamgeeChatMessageRead } from "~/types/message";
import { getEventStream } from "~/lib/api";
import { useGlobalStore } from "~/stores/store-provider";
import { parseEventMessage, getFinalMessage } from "./helpers";
import styles from "./streaming-message.module.css";
import MarkdownContainer from "~/components/markdown-container/markdown-container";

const BlinkingCursor = () => <span className={styles.blinkingCursor}>•</span>;

export default function StreamingMessage({ message, scrollToBottom }: { message: GamgeeChatMessageRead, scrollToBottom: () => void }) {
  const containerRef = useRef<HTMLDivElement>(null);
  useResizeObserver(containerRef, (entry) => {
    scrollToBottom();
  });
  const { markStreamingFinished } = useGlobalStore((state: any) => state);
  const [streamedMessages, setStreamedMessages] = useState([]);
  const [streamEnded, setStreamEnded] = useState(false);

  useEffect(() => {
    const eventSource = getEventStream(
      `/api/v1/chat/connectToStream?session_id=${message.session_id}&message_id=${message._id}`
    );
    eventSource.addEventListener("message", (event) => {
      const { channelName, messages } = parseEventMessage(event.data);
      // @ts-ignore
      setStreamedMessages((prev) => [...prev, ...messages]);
      scrollToBottom();
    });
    eventSource.addEventListener("error", (event) => {
      console.log("Event source error:", event);
      setStreamEnded(true);
      eventSource.close();
    });
  }, []);

  useEffect(() => {
    if (streamEnded) {
      markStreamingFinished(message._id, getFinalMessage(streamedMessages));
    }
  }, [streamEnded]);

  return (
    <div ref={containerRef}>
      <MarkdownContainer message={message}>
        {getFinalMessage(streamedMessages)}
      </MarkdownContainer>
      {!streamEnded && <BlinkingCursor />}
    </div>
  );
}
